export default __webpack_public_path__ + "static/media/SignUp.305118bb.png";